import layout from '@/components/layout/layout'
import {localLanguageVal} from "@/utils/autoScale";
let localLanguage=localLanguageVal()
const program = {
  path: '',
  name: 'program',
    redirect: '',
  component: layout,
  children: [{
    path: localLanguage+'/program',
    redirect: '',
      name: 'program',
    component: () => import('@/views/program/index')
  },{
      path: localLanguage+'/program/list/:type',
      redirect: '',
      name: 'program',
      component: () => import('@/views/program/list')
  },{
      path:localLanguage+ '/program/detail/:type/:id',
      redirect: '',
      name: 'program',
      component: () => import('@/views/program/detail')
  }]
}

export default program
